// useRoomStatusVisibility.js
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {getConfig} from "../../reducers/configSlice";

const useRoomStatusVisibility = () => {
    const config = useSelector(getConfig);
    const [hideRoomStatus, setHideRoomStatus] = useState(false);

    useEffect(() => {
        setHideRoomStatus(parseInt(config.light_driver.mode.id) === 0 || parseInt(config.light_driver.mode.id) === 2);
    }, [config]);

    return hideRoomStatus;
};

export default useRoomStatusVisibility;
